(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["victoria-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('victoria-infinite-marquee')) {
    class VictoriaInfiniteMarquee extends HTMLElement {
      constructor() {
        super();

        this.refreshMarquee = this.refreshMarquee.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector(
          '[data-victoria-viewport]'
        );

        this.track = this.querySelector(
          '[data-victoria-track]'
        );

        this.source = this.querySelector(
          '[data-victoria-source]'
        );

        if (!this.viewport || !this.track || !this.source) {
          return;
        }

        this.resizeObserver = new ResizeObserver(
          this.refreshMarquee
        );

        this.resizeObserver.observe(this.viewport);

        requestAnimationFrame(this.refreshMarquee);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) {
              this.refreshMarquee();
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      removeExistingClones() {
        this.track
          .querySelectorAll('[data-victoria-clone]')
          .forEach((clone) => clone.remove());
      }

      removeShopifyEditorAttributes(element) {
        const elements = [
          element,
          ...element.querySelectorAll('*')
        ];

        elements.forEach((child) => {
          Array.from(child.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) {
              child.removeAttribute(attribute.name);
            }
          });
        });
      }

      refreshMarquee() {
        if (!this.isConnected) {
          return;
        }

        this.classList.remove('victoria-marquee--ready');
        this.removeExistingClones();

        const sourceWidth = Math.ceil(
          this.source.getBoundingClientRect().width
        );

        const viewportWidth = Math.ceil(
          this.viewport.getBoundingClientRect().width
        );

        if (sourceWidth <= 0 || viewportWidth <= 0) {
          return;
        }

        const groupsNeeded = Math.max(
          3,
          Math.ceil(viewportWidth / sourceWidth) + 2
        );

        for (
          let index = 1;
          index < groupsNeeded;
          index += 1
        ) {
          const clone = this.source.cloneNode(true);

          clone.removeAttribute('data-victoria-source');
          clone.setAttribute('data-victoria-clone', '');
          clone.setAttribute('aria-hidden', 'true');

          this.removeShopifyEditorAttributes(clone);
          this.track.appendChild(clone);
        }

        this.style.setProperty(
          '--victoria-marquee-shift',
          `-${sourceWidth}px`
        );

        void this.track.offsetWidth;

        this.classList.add('victoria-marquee--ready');
      }
    }

    customElements.define(
      'victoria-infinite-marquee',
      VictoriaInfiniteMarquee
    );
  }

  } catch(e) { console.error(e); }
})();
})();
